import { useWallDataContext } from "contexts/WallContext";
import styled from "styled-components";
import Chapter from "../Chapter/сhapter";
import DraftChapter from "../DraftChapter/draftChapter";
import { ChapterDisplayDataProvider } from "contexts/ChapterDisplayContext";
import {motion} from "framer-motion";
import { Typography } from "@atoms";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Empty = styled(Typography)`
  margin-top: 8px;
  text-align: center;
`

export default function ChaptersList() {
  const { t } = useTranslation();
  const {chapters, draftChapters, isCreator} = useWallDataContext();

  if ((!chapters || chapters.length === 0) && (!draftChapters || draftChapters.length === 0)) {
    return <Empty as="h4">{t(isCreator ? "wall.emptyCreator" : "wall.empty")}</Empty>;
  }

  return (
    <Wrapper>
      {isCreator && draftChapters.map((draft) => {
        return <DraftChapter key={draft.uuid} chapter={draft}/>;
      })}
      {chapters.filter(c => isCreator || !c.is_hidden).map((chapter) => {
        return (
          <motion.div key={chapter.uuid} layout="position">
            <ChapterDisplayDataProvider chapter={chapter}>
              <Chapter/>
            </ChapterDisplayDataProvider>
          </motion.div>
        );
      })}

    </Wrapper>
  )
}
